import styled from 'styled-components';

import createFormSkinStyles from '../controlskin';

const FormTextarea = styled.textarea`
  ${createFormSkinStyles}
  height: auto;
  min-height: 8rem;
  resize: none;
`;

export default FormTextarea;
